import type { CustomerRecord, Deposit } from '@/domain/types';

/**
 * Every deposit belonging to a customer.
 *
 * `customer.deposits` is the same unreliable back-link as `customer.pieces`: the
 * seed fills it for roughly half the roster and leaves the rest empty, so a
 * record with four deposits on file can read as having none. Resolve forwards by
 * `customerId` and union the back-link, the same shape as piecesForCustomer.
 */
export function depositsForCustomer(
  deposits: Record<string, Deposit>,
  customer: Pick<CustomerRecord, 'id' | 'deposits'>,
): Deposit[] {
  const out = Object.values(deposits).filter((d) => d.customerId === customer.id);
  for (const id of customer.deposits ?? []) {
    const d = deposits[id];
    if (d && !out.some((o) => o.id === d.id)) out.push(d);
  }
  return out;
}

/** How much of a deposit is still to come. Zero once it is settled. */
export function outstandingOnDeposit(d: Deposit): number {
  const paid = d.amountPaid ?? (d.status === 'paid' ? d.amountAud : 0);
  return Math.max(0, d.amountAud - paid);
}
